import React from 'react';
import ResourceAccordionExample from './ResourceAccordionExample';
const Header = () => {
    return (React.createElement(ResourceAccordionExample, null));
};
export default Header;
